import React from "react";
import style from "./TopTalentCard.module.css";
import {Ellipse1, Ellipse2, Wallet} from "../../assets";
import { Link } from "react-router-dom";

export default function TopTalentCard({ heading, content, cardBGColor, hColor, pColor, imgColor }) {
  return (
    <div 
        className={style.container}
        style={{backgroundColor: cardBGColor}} 
        data-aos="zoom-in" data-aos-duraion="1000"
    >
        <img src={Ellipse2} style={{backgroundColor: imgColor}} alt="Ellipse2" />
        
        <h1 style={{color: hColor}}>{heading}</h1>
        
        <div className={style.content_container}>
            <div className={style.image_container}>
                <img src={Wallet} alt="Wallet" />
            </div>
            <div className={style.text_container} style={{color: pColor}}>
                <h1 style={{color: hColor}}>{heading}</h1>
                <p>{content}</p>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "1rem"}}>
                    <Link to="/jobs" className={`${style.b1Link} ${style.Link}`}>Find a Job</Link>
                    <Link to="/hire-a-talent" className={`${cardBGColor==="rgb(250 236 222)" ? style.b2LinkForLight : style.b2LinkForDark} ${style.Link}`}>Hire Talent</Link>
                </div>
            </div>
        </div>
        
        <img src={Ellipse1} style={{backgroundColor: imgColor}} alt="Ellipse1" />
    </div>
  );
}